import { render, staticRenderFns } from "./Simulator.vue?vue&type=template&id=4c72b608"
import script from "./Simulator.vue?vue&type=script&setup=true&lang=js"
export * from "./Simulator.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports